module.exports = __webpack_public_path__ + "img/mas.611f3807.png";